import { createAction } from 'redux-actions';

import fetch from 'features/common/fetch';

import { CLEAR_SEARCH, SET_POLICIES } from './actionTypes';

const setPolicies = createAction(SET_POLICIES, (response) => response);

export const searchPolicy = (policyNo, proposalNo) => (dispatch) => {
	const queryParams = {
		policyNo,
		proposalNo,
	};

	dispatch(fetch.actions.get(fetch.constants.urls.policy, { queryParams })).then((response) => {
		if (Array.isArray(response.body)) {
			dispatch(setPolicies(response.body));
		}
	});
};

export const clearSearch = createAction(CLEAR_SEARCH);
